/** @format */

import { useContext } from 'react';
import SettingsContext, { type SettingsContextValue } from 'src/contexts/SettingsContext';

const useSettings = (): SettingsContextValue => useContext(SettingsContext);

export default useSettings;
